import { render, staticRenderFns } from "./workCenterDowntime-add-or-update.vue?vue&type=template&id=327f007e&scoped=true"
import script from "./workCenterDowntime-add-or-update.vue?vue&type=script&lang=js"
export * from "./workCenterDowntime-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./workCenterDowntime-add-or-update.vue?vue&type=style&index=0&id=327f007e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327f007e",
  null
  
)

export default component.exports